const Portfolio = () => {

  return (
  <div className='devProjectsBoxes'>
         <div className='designImgContainer'>
        <img className='projectImage' alt='Just Bee Site Screenshot' src='https://res.cloudinary.com/dkkwdvec2/image/upload/v1723590722/Screen_Shot_2024-08-13_at_7.03.37_PM_ezg4ps.png'  style={{border: '1px solid lightgray'}}/>
        <p></p>
        <p><strong>Just Bee</strong><br/>Compelling, fun and responsive design for an autism non-profit. <br/> 
        Developed & maintained using NextJS.
        </p>
        <a className='links' target="_blank" rel="noreferrer" href='https://www.justbeethechange.com/'><strong>Visit Site</strong></a>
    </div>

      <div className='designImgContainer'>
        <img className='projectImage' alt='Greater Things Site Screenshot' src='https://res.cloudinary.com/dkkwdvec2/image/upload/v1723589709/Screen_Shot_2024-08-13_at_6.45.27_PM_fmalz1.png'  style={{border: '1px solid lightgray'}}/>
        <p></p>
        <p><strong>Greater Things</strong><br/>Personable and responsive design for a life coach. <br/> 
        Developed & maintained using Wordpress.
        </p>
        <a className='links' target="_blank" rel="noreferrer" href='https://greaterthingsllc.com/'><strong>Visit Site</strong></a>
    </div>

    <div className='designImgContainer'>
        <img className='projectImage' alt='Standridge Color Site Screenshot' src='https://res.cloudinary.com/dkkwdvec2/image/upload/v1723590158/Screen_Shot_2024-08-13_at_6.57.31_PM_ljfbuq.png'  style={{border: '1px solid lightgray'}}/>
        <p></p>
        <p><strong>Standridge Color</strong><br/>Professional and responsive design for a manufacturing company. <br/> 
        Developed & maintained using Wordpress.
        </p>
        <a className='links' target="_blank" rel="noreferrer" href='https://standridgecolor.com/'><strong>Visit Site</strong></a>
    </div>

    <div className='designImgContainer'>
        <img className='projectImage' alt='GG Ventures site screenshot' src='https://res.cloudinary.com/dkkwdvec2/image/upload/v1663262657/ggv-01_yhw1kl.png'  style={{border: '1px solid lightgray'}}/>
        <p></p>
        <p><strong>GG Ventures</strong><br/>Trust-inspiring, responsive design for a venture capital firm. <br/> 
        Developed & maintained using Wordpress.
        </p>
        <a className='links' target="_blank" rel="noreferrer" href='https://amp-sys.com/'><strong>Visit Site</strong></a>
    </div>

    <div className='designImgContainer'>
        <img className='projectImage' alt='AMPS site screenshot' src='https://res.cloudinary.com/dkkwdvec2/image/upload/v1649774789/AMPSYS_h0pg2s.png'  style={{border: '1px solid lightgray'}}/>
        <p></p>
        <p><strong>AMPS</strong><br/>Clean, modern design for an energy-efficient generator company. <br/> 
        Developed & maintained using Wordpress.
        </p>
        <a className='links' target="_blank" rel="noreferrer" href='https://amp-sys.com/'><strong>Visit Site</strong></a>
    </div>

    <div className='designImgContainer'>
        <img className='projectImage' alt='Livewell Site screenshot' src='https://res.cloudinary.com/dkkwdvec2/image/upload/v1649774792/Livewell_eghbst.png'  style={{border: '1px solid lightgray'}}/>
        <p></p>
        <p><strong>LiveWell Greenville</strong><br/>Simple and engaging design for a local non-profit organization.<br/> 
        Developed & maintained using Wordpress.
        </p>
        <a className='links' target="_blank" rel="noreferrer" href='https://livewellgreenville.org/'><strong>Visit Site</strong></a>
    </div>

    {/* <div className='designImgContainer'>
        <img className='projectImage' rel="noreferrer" alt='Rec site screenshot' src='https://res.cloudinary.com/dkkwdvec2/image/upload/v1649790853/Rec_feekav.png'  style={{border: '1px solid lightgray'}}/>
        <p></p>
        <p><strong>Greenville County Rec</strong><br/>Fun, playful design for a parks and recreation department.<br/> 
        Updated & maintained using Wordpress.
        </p>
        <a className='links' target="_blank" rel="noreferrer" href='https://greenvillerec.com/'><strong>Visit Site</strong></a>
    </div> */}
    
  </div>
  )
}

export default Portfolio;